module.exports = __webpack_public_path__ + "static/media/urlshort.df8279ce.gif";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/img/urlshort.gif
// module id = 361
// module chunks = 0